export default __webpack_public_path__ + "static/media/owl-2.5f317e5a.png";